<template>
  <ServicePageLayout
    title="Report"
    subtitle="รายงาน"
    icon="mdi-chart-box-outline"
    breadcrumb="Reports"
  >
    <v-card flat class="service-content-panel">
      <v-card-text><Table /></v-card-text>
    </v-card>
  </ServicePageLayout>
</template>

<script>
import ServicePageLayout from '@/components/layout/ServicePageLayout.vue'
import Table from '@/components/report/report_table.vue'

export default {
  name: 'ReportView',
  components: {
    ServicePageLayout,
    Table
  },
}
</script>
